import Decimal from 'decimal.js';
import Numeric   from '@/core/types/Numeric';
import Area      from '@/core/types/Area';
import Title_ru_RU_Class from '@/core/misc/decorators/Title_ru_RU_Class';

/**
 * Линейный размер. Точность — 0 знаков.
 *
 * Единица — МИЛЛИМЕТРЫ: габариты грузового места (длина/ширина/высота)
 * хранятся и вводятся целыми мм. Тип — первое звено цепочки
 * Dimension × Dimension × Dimension → Volume: два умножения дают Area (мм²),
 * третье — Volume (м³, конверсия единиц один раз в Area.mul).
 *
 * Округление — БЕЗУСЛОВНО ВВЕРХ (как Volume): габарит никогда не занижаем,
 * чтобы объём места не оказался меньше фактического. При целом вводе no-op,
 * срабатывает только на дробном хвосте. Зеркало на беке:
 * RoundingMode::AwayFromZero.
 *
 * Зеркальный бекенд: core/types/Dimension.php на BcMath\Number.
 */
@Title_ru_RU_Class('Размер')
class Dimension extends Numeric {
    static readonly SCALE = 0;
    protected static readonly ROUNDING: Decimal.Rounding = Decimal.ROUND_UP;

    static fromServer(value: string): Dimension {
        return new Dimension(value);
    }

    /** Результат вычисления — уже посчитанный Decimal. */
    static fromOperation(value: Decimal): Dimension {
        return new Dimension(value);
    }

    /** Размер × размер = площадь (мм²). Дальше Area.mul(высота) → Volume. */
    mul(other: Dimension | null | undefined): Area {
        return Area.fromOperation(this.value.times(Dimension.toDecimal(other)));
    }

    /** Габарит показываем целым числом мм без разделителей разрядов:
     * это линейный размер, не денежная величина — группировка тысяч не нужна.
     * Пустое (не введённое) значение печатается пустой строкой, а не "NaN". */
    format(): string {
        if (this.isEmpty()) {
            return '';
        }

        return this.value.toFixed(0);
    }
}

export default Dimension;